import axios from "axios";

const getAuthToken = () => {
  const token = JSON.parse(localStorage.getItem("token"));
  return { headers: { Authorization: `Bearer ${token}` } };
};

const makeGetRequest = (url, config, withToken = false) => {
  const tokenHeaders = withToken ? getAuthToken() : null;
  return axios
    .get(url, {
      ...config,
      ...tokenHeaders,
    })
    .then((response) => response)
    .catch((error) => error.response);
};

function makePostRequest(url, bodyFormData, config, withToken = false) {
  const tokenHeaders = withToken ? getAuthToken() : null;

  return axios
    .post(url, bodyFormData, {
      ...config,
      ...tokenHeaders,
    })
    .then((response) => response)
    .catch((error) => error.response);
}

function makePatchRequest(url, bodyFormData, config, withToken = false) {
  const tokenHeaders = withToken ? getAuthToken() : null;

  return axios
    .patch(url, bodyFormData, {
      ...config,
      ...tokenHeaders,
    })
    .then((response) => response)
    .catch((error) => error.response);
}

function makeDeleteRequest(url, config, withToken = false) {
  const tokenHeaders = withToken ? getAuthToken() : null;

  return axios
    .delete(url, {
      ...config,
      ...tokenHeaders,
    })
    .then((response) => response)
    .catch((error) => error.response);
}

function makePutRequest(url, bodyFormData, config, withToken = false) {
  const tokenHeaders = withToken ? getAuthToken() : null;

  return axios
    .put(url, bodyFormData, {
      ...config,
      ...tokenHeaders,
    })
    .then((response) => response)
    .catch((error) => error.response);
}
export {
  makeGetRequest,
  makePostRequest,
  makePatchRequest,
  makePutRequest,
  makeDeleteRequest,
};
